import { HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ALLOWED_VIDEO_TYPE } from '../../constants/constants';
import { MediaCategory } from '../../enums/enums';
import { MediaSignedUrlModel } from '../../interface/interface';
import { SharedService } from '../../services/shared.service';
import { SharedModule } from '../../shared.module';
import { CircleProgressComponent } from '../circle-progress/circle-progress.component';

@Component({
  selector: 'app-upload-video',
  standalone: true,
  templateUrl: './upload-video.component.html',
  styleUrl: './upload-video.component.scss',
  imports: [SharedModule, CircleProgressComponent],
})
export class UploadVideoComponent implements OnDestroy {
  @Output() uploadStart: EventEmitter<void> = new EventEmitter();
  @Output() uploadEnd: EventEmitter<MediaSignedUrlModel | null> =
    new EventEmitter();
  @Input() previewUrl: string = '';
  @Output() removeVideo: EventEmitter<void> = new EventEmitter();
  videoUploading = false;
  loadingPercentage = 0;
  subscription = new Subscription();
  constructor(
    private toastr: ToastrService,
    private sharedService: SharedService
  ) {}

  onFileSelction = async (event: any) => {
    const file: File = event?.target?.files?.[0];
    if (file) {
      if (
        (file.type && !ALLOWED_VIDEO_TYPE.includes(file.type)) ||
        (file.type === '' && !file.name.toLowerCase().endsWith('.mkv'))
      ) {
        this.toastr.error('Please enter a valid video');
        return;
      }

      this.uploadStart.emit();
      this.videoUploading = true;
      const signedUrlSub = this.sharedService
        .getMediaSignedUrl({
          fileName: file.name,
          contentType: file.type,
          category: MediaCategory.VIDEO,
        })
        .subscribe({
          next: (data: MediaSignedUrlModel) => {
            const uploadFileSub = this.sharedService
              .uploadFileWithReportProgress(data.uploadUrl, file)
              .subscribe({
                next: (resp) => {
                  if (resp.type === HttpEventType.Response) {
                    this.videoUploading = false;
                    this.uploadEnd.emit(data);
                  }
                  if (resp.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round(
                      (100 * resp.loaded) / resp.total
                    );
                    this.loadingPercentage = percentDone;
                  }
                },
                error: (err) => {
                  this.uploadEnd.emit(null);
                  this.videoUploading = false;
                  this.toastr.error(
                    err?.error?.message ||
                      err?.message ||
                      'Something went wrong!'
                  );
                },
              });
            this.subscription.add(uploadFileSub);
          },
          error: (err) => {
            this.uploadEnd.emit(null);
            this.videoUploading = false;
            this.toastr.error(
              err?.error?.message || err?.message || 'Something went wrong!'
            );
          },
        });
      this.subscription.add(signedUrlSub);
    }
  };

  handleRemoveVideo() {
    this.removeVideo.emit();
    this.loadingPercentage = 0;
  }

  get allowedVideoTypes() {
    return ALLOWED_VIDEO_TYPE.join(',');
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
